import { Empty } from 'antd'
import { GraphMessageState } from './graph-message-state'

interface EmptyGraphStateProps {
  message: string
  onCancel: () => void
}

export function EmptyGraphState({ message, onCancel }: EmptyGraphStateProps) {
  return <GraphMessageState icon={<Empty description={false} />} message={message} onClose={onCancel} />
}
